module.exports = __webpack_public_path__ + "img/Pharmacie.5341a198.jpg";